import React, { useState, useEffect } from 'react';
import './StudentResults.css';
import { apiFetch } from './api';

function StudentResults({ studentId }) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (studentId) {
      fetchResults();
    } else {
      console.warn('StudentResults: studentId is missing');
      setLoading(false);
      setError('Öğrenci bilgisi bulunamadı');
    }
  }, [studentId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Otomatik yenileme - 30 saniyede bir sessiz güncelleme
  useEffect(() => {
    if (!studentId) return;
    
    const interval = setInterval(() => {
      // Sessiz güncelleme - loading state'i değiştirme
      fetchResults(true).catch(err => console.error('Otomatik yenileme hatası:', err));
    }, 30000); // 30 saniye

    return () => clearInterval(interval);
  }, [studentId]);

  const fetchResults = async (silent = false) => {
    try {
      if (!silent) {
        setLoading(true);
        setError('');
      }
      const response = await apiFetch(`/student/results`);
      const data = await response.json();

      console.log('StudentResults API Response:', data);

      if (data.success) {
        setResults(data.results || []);
        if (!data.results || data.results.length === 0) {
          console.log('No results found in response');
        }
      } else {
        if (!silent) {
          setError(data.message || 'Sonuçlar yüklenemedi');
        }
      }
    } catch (err) {
      if (!silent) {
        setError('Bağlantı hatası');
      }
      console.error('Error fetching results:', err);
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    // Backend'den gelen tarih timezone-naive (direkt veritabanından)
    const [datePart, timePart] = dateString.split('T');
    if (!datePart || !timePart) return '-';
    
    const [year, month, day] = datePart.split('-').map(Number);
    const [timeStr] = timePart.split('.');
    const [hour, minute, second = 0] = timeStr.split(':').map(Number);
    
    // Direkt veritabanındaki saati göster (timezone dönüşümü yok)
    return `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year} ${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;
  };

  const getGradeColor = (total_points) => {
    if (total_points >= 70) return 'grade-excellent';
    if (total_points >= 50) return 'grade-good';
    return 'grade-poor';
  };

  if (loading) {
    return (
      <div className="dashboard-section">
        <h2>Sonuçlarım</h2>
        <div className="loading-state">
          <p>Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-section">
        <h2>Sonuçlarım</h2>
        <div className="error-state">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-section">
      <h2>Sonuçlarım</h2>
      {results.length === 0 ? (
        <div className="empty-state">
          <p>Henüz sınav sonucunuz bulunmamaktadır.</p>
        </div>
      ) : (
        <div className="results-list">
          {results.map((result) => (
            <div key={result.result_id} className="result-card">
              <div className="result-header">
                <h3>{result.exam_title}</h3>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                  <span className={`result-grade-badge ${getGradeColor(result.total_points)}`}>
                    {result.total_points.toFixed(2)} puan
                  </span>
                </div>
              </div>
              <div className="result-details">
                <div className="result-info-card result-info-full">
                  <span className="info-label">Ders:</span>
                  <span className="info-value">{result.course_name}</span>
                </div>
                <div className="result-info-card">
                  <span className="info-label">Sınavın Ağırlığı:</span>
                  <span className="info-value">
                    {result.weight ? `%${result.weight}` : '-'}
                  </span>
                </div>
                <div className="result-info-card">
                  <span className="info-label">Başlangıç:</span>
                  <span className="info-value">{formatDate(result.started_at)}</span>
                </div>
                <div className="result-info-card">
                  <span className="info-label">Teslim:</span>
                  <span className="info-value">{formatDate(result.submitted_at)}</span>
                </div>
                <div className="result-info-card">
                  <span className="info-label">Hesaplanma:</span>
                  <span className="info-value">{formatDate(result.calculated_at)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default StudentResults;

